export default __webpack_public_path__ + "assets/837e0a4eb998adee11cf6a2c1351bfc2.jpg";